<template>
  <b-row>

    <b-col cols="12">
      <!-- PERMISSION TABLE -->
      <b-card no-body class="border">

        <div v-if="requestPending" class="loading_page" style=" padding: 10px;">
          <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>

        <b-card-header class="p-1">
          <b-card-title class="font-medium-2">
            <feather-icon icon="LockIcon" size="18" />
            <span class="align-middle ml-50">{{ $t('Groups Permission') }}</span>
          </b-card-title>
        </b-card-header>


        <!--          <devices-filter :contract-filter.sync="contractFilter"-->
        <!--                          :contract-options="contractsOptions"-->
        <!--                          :group-filter.sync="groupFilter"-->
        <!--                          :groups-options="groupsOptions"-->
        <!--                          :categories-options="categoriesOptions"-->
        <!--                          :category-filter.sync="categoryFilter"-->
        <!--                          :owner-filter.sync="ownerFilter"-->
        <!--                          :owners-options="ownersOptions">-->

        <!--          </devices-filter>-->


        <div class="m-2">

          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col cols="12" md=6>
              <!-- Action Buttons -->
              <b-button type="submit" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="submit">
                {{ $t('Save Changes') }}
              </b-button>
            </b-col>

            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{ $t('entries') }}</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')" />
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table striped responsive class="mb-0" :items="authGroups" :fields="fields">

          <template #head(list)="data">
            <b-form-checkbox v-model="isAllChecked" @change="checkAll(data, $event)" />
          </template>

          <template #cell(name)="data">
            {{ data.value }}
          </template>

          <template #cell()="data">
            <b-form-checkbox :state="userGroups.includes(data.item.id) ? true : null"
              :checked="requestIds.includes(data.item.id)" @change="change(data, $event)" />
          </template>

        </b-table>

        <div class="mx-2 mb-2">
          <b-row>

            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">
                {{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{ $t('of') }} {{ dataMeta.of }}
                {{ $t('entries-devices') }}
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <b-pagination v-model="currentPage" :total-rows="totalTable" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-col>




  </b-row>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia, BPagination,
  BMediaAside,
  BMediaBody,
  BLink, BBadge,
  BImg,
  BTable, BFormCheckbox, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, computed, watch, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import permissionsStoreModule from '@/views/modules/user/users-edit/permissions/permissionsStoreModule'
import usePermissions from '@/views/modules/user/users-edit/permissions/usePermissions'
import DevicesFilter from '@/views/modules/user/users-edit/permissions/DevicesFilter'
import { OrbitSpinner } from 'epic-spinners'
import filters from '@/views/modules/Utils/filters'

export default {
  components: {
    BButton, BForm, BImg, BFormFile,
    BFormGroup, BFormInput, BRow,
    BCol, BAlert, BCard, BCardText, BBadge,
    BMedia, BMediaAside, BMediaBody, vSelect, BPagination,
    BLink, BTable, BFormCheckbox, BCardTitle, BCardHeader, DevicesFilter, OrbitSpinner
  },
  directives: {
    Ripple,
  },
  props: {
    user: {
      type: Number,
      required: true
    },
  },

  setup(props, { root, emit }) {

    const isAllChecked = ref(false)
    const requestPending = ref(false)
    const authGroups = ref([])
    const userGroups = ref([])
    const current_selected = ref([]);

    const { perPage, perPageOptions, searchQuery, currentPage, totalTable, dataMeta } = usePermissions()

    const filter = ref({})

    watch([currentPage, perPage, searchQuery], () => {
      filter.value = {
        ...(searchQuery.value && { q: searchQuery.value }),
      }
      fetchAuthGroups()
    })


    const PERMISSION_STORE = 'app-permission'

    if (!store.hasModule(PERMISSION_STORE))
      store.registerModule(PERMISSION_STORE,
        permissionsStoreModule)

    if (store.hasModule(PERMISSION_STORE))
      onUnmounted(() => {
        store.unregisterModule(PERMISSION_STORE)
      })


    const fetchAuthGroups = () => {
      requestPending.value = true
      store.dispatch('app-permission/userGetLinked', {
        length: perPage.value,
        page: currentPage.value,
        user: store.state.auth.userData.id,
        type: 'group',
      }).then(response => {
        requestPending.value = false
        const { total, data } = response.data.data
        totalTable.value = total
        authGroups.value = data
        if (isAllChecked.value == true) { checkAll(undefined, true) }
      }).catch(res => {
        requestPending.value = false
      })
    }

    fetchAuthGroups()

    store.dispatch('app-permission/userGetLinked', { user: props.user, type: 'group' })
      .then(res => {
        requestIds.value = res.data.data.map(d => d.id)
        userGroups.value = res.data.data.map(d => d.id)
      }).catch(res => { })


    const fields = ['name', 'list']


    const checkAll = (data, value) => {


      if (value) {
        authGroups.value.map(item => {
          if (requestIds.value.indexOf(item.id) == -1) {
            requestIds.value.push(item.id)
          }
        })
        requestIds.value.map((v) => {

          if (current_selected.value.indexOf(v) < 0) {
            current_selected.value.push(v)
          }
        })

      } else {
        authGroups.value.map(item => {
          const index = current_selected.value.indexOf(item.id)

          if (index !== -1) current_selected.value.splice(index, 1)
        })
      }
      // requestIds.value=[]
      // requestIds.value=current_selected.value;
      requestIds.value = JSON.parse(JSON.stringify(current_selected.value))




    }


    const submit = () => {
      requestPending.value = true
      store.dispatch('app-permission/userLinkTo', {
        user: props.user,
        type: 'group',
        ids: requestIds.value
      }).then(res => {

        requestPending.value = false
        toaster('Groups Updated Successfully', 'success', 'success')
        changedIds.value = []
        userGroups.value = requestIds.value.map(x => x)


      }).catch(reason => {
        requestPending.value = false
        toaster('Error Happened On Link Groups', 'error', 'Error')
      })
    }

    const requestIds = ref([])
    const changedIds = ref([])


    const change = (data, value) => {
      const index = requestIds.value.indexOf(data.item.id);
      if (value && index === -1) requestIds.value.push(data.item.id)
      else requestIds.value.splice(index, 1)
    }


    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    return {
      authGroups,
      userGroups,
      perPage,
      perPageOptions,
      currentPage,
      searchQuery,
      totalTable,
      dataMeta,
      change,
      fields,
      submit,
      checkAll,
      isAllChecked,
      fetchAuthGroups,
      // ownersOptions,
      // contractsOptions,
      // categoriesOptions,
      // groupsOptions,
      // ownerFilter,
      // groupFilter,
      // contractFilter,
      // categoryFilter,
      requestIds,
      requestPending
    }
  },
}
</script>
